import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import CookieConsent from 'react-cookie-consent'; /* temporary banner will be live from April 21 - May 5 at noon */

import Blade from '../Blade';
import { Context } from '../../Providers/Blade';
import SkipToContent from '../SkipToContent';
import MenuItem from '../MenuItem';

import { MobileNav, DesktopNav, InfoBar } from './layout';
import {
  StyledHeader,
  Wrapper,
  LogoLink,
  Logo,
  Menu,
  Play,
  Overlay,
  StyledPromo,
} from './styles';

export function Header({ data, location, navHeader }) {
  if (!data) return null;
  // * We keep the state for the header menu contained within contentxt
  const { state, resetState } = useContext(Context);

  // * Destructuring the fields off of data
  const {
    image: logo,
    imageSharp: logoSharp,
    menu,
    loginLink,
    loginText,
    playLink,
    playText,
    infobarBackgroundColor,
    infobarForegroundColor,
    infobarTextHtml,
    infobarCtaText,
    infobarCtaUrl,
    infobarCtaStyle,
    infobarCtaText2,
    infobarCtaUrl2,
    infobarCtaStyle2,
    infobarPages,
    lang,
  } = data;

  const navCtaArray = navHeader.filter((header) => {
    if (location && location.pathname.includes(header.headerNavCtaUrl)) {
      return location.pathname.includes(header.headerNavCtaUrl);
    }
    return undefined;
  });

  const navCta = navCtaArray[0];

  const [openSections, setOpenSections] = useState({});

  // * We use the double ! because if the label doesnt exist in state it will return undefined, and by using the double ! we can convert the undefined to false
  const onClick = (label) => {
    const isOpen = !!openSections[label];
    setOpenSections({
      [label]: !isOpen,
    });
  };

  return (
    <>
      <Overlay
        isOpen={Object.values(openSections).includes(true)}
        onClick={() => setOpenSections({})}
      />
      {(!navCta || navCta.showHeaderNav !== false) && (
        <StyledHeader>
          <SkipToContent />
          {location && infobarPages.includes(location.pathname) && (
            <CookieConsent
              expires={14}
              contentStyle={{ margin: '0' }}
              style={{
                background: infobarBackgroundColor,
                color: '#000',
                textAlign: 'center',
                position: 'inherit',
                margin: '0',
              }}
              buttonStyle={{
                background: infobarBackgroundColor,
                fontSize: '16px',
                color: infobarForegroundColor,
              }}
              buttonClasses="infobar-close"
              buttonText="x"
              hideOnAccept="true"
              location="top"
            >
              <InfoBar
                background={infobarBackgroundColor}
                foreground={infobarForegroundColor}
                textHtml={infobarTextHtml}
                ctaText={infobarCtaText}
                ctaUrl={infobarCtaUrl.url}
                ctaStyle={infobarCtaStyle}
                ctaText2={infobarCtaText2}
                ctaUrl2={infobarCtaUrl2 ? infobarCtaUrl2.url : undefined}
                ctaStyle2={infobarCtaStyle2}
                lang={lang}
              />
            </CookieConsent>
          )}
          <Wrapper className="auto-margin">
            <LogoLink
              className="inline"
              to="/"
              name="prodigy"
              ariaLabel="go to Prodigy homepage"
              lang={lang}
            >
              <Logo src={logoSharp.publicURL} alt={logo.altTag} />
            </LogoLink>
            <DesktopNav
              menu={menu}
              openSections={openSections}
              location={location}
              onClick={onClick}
              loginLink={loginLink}
              loginText={loginText}
              playLink={playLink}
              playText={playText}
              resetState={() => setOpenSections({})}
              navCta={navCta}
              lang={lang}
            />
            <MobileNav
              loginLink={loginLink}
              loginText={loginText}
              location={location}
              navCta={navCta}
            />
          </Wrapper>
          <Blade
            title="test-blade"
            isOpen={state}
            logo={logo}
            logoSharp={logoSharp}
          >
            <>
              {menu && (
                <Menu className="no-bullets">
                  {menu.map((info, index) => (
                    <li key={`menu-item-${index.toString()}`}>
                      <MenuItem
                        data={info}
                        isOpen={!!openSections[info.text]}
                        label={info.text}
                        onClick={onClick}
                        resetState={() => resetState()}
                        font="Work Sans"
                        lang={lang}
                      />
                    </li>
                  ))}
                </Menu>
              )}
              {(!navCta || navCta.showLoginButton !== false) && (
                <StyledPromo
                  to={loginLink.url}
                  className="ghost-on-light-bg"
                  ariaLabel={loginLink.ariaLabelLogin}
                  queryString={loginLink.queryStringLogin}
                >
                  {loginText}
                </StyledPromo>
              )}
              {navCta && navCta.headerNavCtaUrl !== undefined ? (
                <Play
                  to={navCta.headerNavCtaLink.url}
                  ariaLabel={playLink.ariaLabelPlay}
                  queryString={playLink.queryStringPlay}
                  className={navCta.headerNavCtaButtonStyle}
                  font="Work Sans"
                >
                  {navCta.headerNavCtaButtonText}
                </Play>
              ) : (
                <Play
                  to={playLink.url}
                  className="solid-on-light-bg"
                  ariaLabel={playLink.ariaLabelPlay}
                  queryString={playLink.queryStringPlay}
                  font="Work Sans"
                >
                  {playText}
                </Play>
              )}
            </>
          </Blade>
        </StyledHeader>
      )}

      {/* temporary banner this will be live from April 21 - May 5 at noon */}
      {/* <CookieConsent
        expires={14}
        style={{
          background: '#a9e7f5',
          color: '#000',
          textAlign: 'center',
          position: 'inherit',
        }}
        buttonStyle={{ background: '#a9e7f5', fontSize: '16px' }}
        buttonText="x"
        hideOnAccept="true"
        location="top"
      >
        Hi! We’ve updated our privacy policy
        <a
          style={{ display: 'inline-flex', marginLeft: '20px' }}
          href="https://https://www.prodigygame.com/main-en/privacy-policy/"
        >
          <div style={{ background: '#FFFFFF', width: 'fit-content' }}>
            <p
              style={{
                color: '#FF5C0B',
                margin: '0 15px',
                fontWeight: '600',
                borderRadius: '4px',
                borderWidth: '3px',
              }}
            >
              Read full policy
            </p>
          </div>
        </a>
      </CookieConsent> */}
    </>
  );
}

Header.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  navHeader: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  lang: PropTypes.string,
};

Header.defaultProps = { location: null, lang: 'en-ca' };

const withStaticQueryHeader = ({ location, lang }) => (
  <StaticQuery
    query={graphql`
      query headerQuery {
        prodigy {
          englishNav: headerNavCtaMappings(locale: "en-ca") {
            headerNavCtaButtonStyle
            headerNavCtaButtonText
            headerNavCtaUrl
            headerNavCtaLink {
              url
            }
            showLoginButton
            showHeaderNav
          }
          indianNav: headerNavCtaMappings(locale: "en-in") {
            headerNavCtaButtonStyle
            headerNavCtaButtonText
            headerNavCtaUrl
            headerNavCtaLink {
              url
            }
            showLoginButton
            showHeaderNav
          }
          headerFooter {
            header {
              lang
              image {
                url
                altTag
              }
              imageSharp {
                publicURL
              }
              loginText
              loginLink {
                url
              }
              playText
              playLink {
                url
              }
              menu {
                text
                type
                url
                subitems {
                  text
                  type
                  url
                  subitems {
                    text
                    type
                    url
                    linkType
                    queryString
                    ariaLabel
                  }
                  queryString
                  ariaLabel
                }
                ariaLabel
                queryString
              }
              queryStringPlay
              queryStringLogin
              ariaLabelPlay
              ariaLabelLogin
              infobarBackgroundColor
              infobarForegroundColor
              infobarTextHtml
              infobarCtaText
              infobarCtaUrl {
                url
              }
              infobarCtaStyle
              infobarCtaText2
              infobarCtaUrl2 {
                url
              }
              infobarCtaStyle2
              infobarPages
            }
          }
        }
      }
    `}
    render={({ prodigy }) => {
      const { header } = prodigy.headerFooter.find(
        ({ header: headerData }) =>
          headerData.lang ===
          /* the footer/header has 2 (english and indian) versions of the site, this logic determines which version to use based on the locale
            of which there are several (en,en-ca,en-us,x-default,etc), therefore only render the indian version when it's locale matches, otherwise always use the english ver */
          (lang !== 'en-in' ? 'en-ca' : 'en-in')
      );
      const navHeader =
        lang !== 'en-in' ? prodigy.englishNav : prodigy.indianNav;
      return <Header data={header} location={location} navHeader={navHeader} />;
    }}
  />
);

export default withStaticQueryHeader;
